module.exports = __webpack_public_path__ + "static/media/om_beard_medium_diamond__v.8962f4e0.png";